<template>
  <div>
    <iModal
      title="新增人员"
      v-model="showModal"
      class-name="vertical-center-modal"
      width="600px"
      :mask-closable="false"
      @on-cancel="cancel"
    >
      <div class="admin-add">
        <div class="admin-add-content">
          <Form
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            label-position="right"
            :label-width="100"
            @submit.native.prevent
          >
            <FormItem label="姓名：" prop="name">
              <Input type="text" v-model="formInline.name" placeholder="请输入姓名" />
            </FormItem>
            <FormItem label="职务：" prop="JobTitle">
              <Input type="text" v-model="formInline.JobTitle" placeholder="请输入职务" />
            </FormItem>
            <FormItem label="手机：" prop="mobile">
              <Input type="text" v-model="formInline.mobile" placeholder="请输入手机" />
            </FormItem>
            <FormItem label="验证码：" class="form-code-item" prop="captcha">
              <Input type="text" v-model="formInline.captcha" placeholder="请输入验证码" />
              <Button type="text" v-if="showCode" @click="getCaptcha" class="form-code-btn">获取验证码</Button>
              <Button type="text" v-else disabled class="form-code-btn">{{count}}s后重新获取</Button>
            </FormItem>
            <FormItem>
              <Checkbox size="large" v-model="formInline.isShow">
                <span style="display: inline-block;width: 10px;"></span>Display
              </Checkbox>
            </FormItem>
            <FormItem label="显示顺序：">
              <InputNumber :min="0" v-model="formInline.showindex"></InputNumber>
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="handleSubmit('formInline')">确定</Button>
        <Button @click="cancel">取消</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import { validator } from "@/other/validator";
import { mapActions, mapGetters } from "vuex";

export default {
  // 新增人员modal
  name: "addOperate",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      showModal: false,
      showCode: true, // 是否可以获取验证码
      count: "", // 获取验证码的秒数
      formInline: {
        // form双向绑定
        name: "", // 姓名
        JobTitle: "", // 职务
        mobile: "", // 手机
        captcha: "", // 验证码
        password: "888888", // 默认密码
        repassword: "888888",
        roleId: "0", // 0 用户; 1 管理员
        isShow: true, // 是否显示
        showindex: 0, // 显示顺序
      },
      ruleInline: {
        // 效验规则
        name: [
          {
            required: true,
            message: "用户为必填选项",
            trigger: "blur"
          }
        ],
        roleId: [
          {
            required: true,
            message: "必填选项",
            trigger: "blur"
          }
        ],
        mobile: validator.phone,
        captcha: [
          {
            required: true,
            message: "验证码为必填选项",
            trigger: "blur"
          }
        ],
        JobTitle: [
          {
            required: true,
            message: "职务为必填选项",
            trigger: "blur"
          }
        ]
      }
    };
  },
  watch: {
    show(val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    }
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany"
    })
  },
  methods: {
    ...mapActions({
      checkUserName: "loginModule/checkUserName",
      getMsgCode: "loginModule/getMsgCode",
      validateMsgCode: "loginModule/validateMsgCode",
      registerExhibition: "registerModule/registerExhibition",
      addStaff: "companyModule/addStaff"
    }),
    async handleSubmit(name) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      let codeValid = await this.validCode();
      if (!codeValid) return;
      let req = {
        Name: form.name,
        UserName: form.mobile,
        PhoneNumber: form.mobile,
        Password: form.password,
        ConfirmPassword: form.repassword,
        RoleId: form.roleId
      };
      // 判断用户名是否注册
      let userId = "";
      let checkUser = await this.checkUserName({ UserName: form.mobile });
      if (checkUser && checkUser.successed) {
        userId = checkUser.info.userId;
      }
      this.loading = true;
      setTimeout(c => {
        this.loading = false;
      }, 5000);
      if (!userId) {
        let user = await this.registerExhibition(req).catch(err => {
          this.loading = false;
        });
        if (!user) {
          userId = user.id;
          this.loading = false;
          this.$Message.error("添加失败，请重新尝试");
          return;
        }
      }
      let req2 = {
        AgentId: this.company.agentId,
        CompId: this.company.id,
        UserId: userId,
        RoleId: Number(form.roleId),
        Name: form.name,
        JobTitle: form.JobTitle,
        // Mob: form.PhoneNumber,
        Mob: form.mobile,
        IsShow: form.isShow,
        ShowIndex: form.showindex
      };
      console.log("req2: ", req2);
      let bool = await this.addStaff(req2).catch(err => {
        this.loading = false;
      });
      if (!bool) {
        this.loading = false;
        this.$Message.error("添加失败，请重新尝试");
      } else if (!bool.successed) {
        this.loading = false;
        this.$Message.error("该手机号已绑定其他账号，请更换手机号");
      } else {
        this.$emit('finish');
        this.$Message.success("添加成功！");
        this.cancel();
      }
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    getCaptcha() {
      this.$refs.formInline.validateField("mobile", val => {
        if (val !== "") return;
        this.downTime();
      });
    },
    async downTime() {
      const valid = await this.getMsgCode(this.formInline.mobile);
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.showCode = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.showCode = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    async validCode() {
      // 验证code
      if (!this.formInline.captcha) return false;
      let valid = await this.validateMsgCode({
        Phone: this.formInline.mobile,
        Code: this.formInline.captcha
      });
      if (!valid) {
        this.$Message.error("验证未通过!");
        return false;
      }
      if (valid.errors && valid.errors[0]) {
        if (valid.errors[0].code === -1) {
          this.$Message.error("无效的验证码");
          return;
        }
        this.$Message.error(valid.errors[0].description);
        return false;
      }
      return true;
    },
    cancel() {
      this.$refs["formInline"].resetFields();
      this.$emit("close");
    }
  }
};
</script>

<style scoped lang="scss">
.admin-add {
  &-content {
    padding: 20px 40px 20px 20px;
  }
}
.admin-add {
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }
  &-content {
    .submit {
      display: flex;
      justify-content: center;
      button {
        margin-left: -75px;
      }
    }
    img {
      width: 150px;
      height: 150px;
    }
  }
  .form-code-item {
    position: relative;
    .form-code-btn {
      position: absolute;
      right: 1px;
      width: 96px;
      top: 2px;
      border: none;
      outline: none;
      &:focus {
        box-shadow: none;
        border: none;
        outline: none;
      }
    }
  }
}
</style>

